var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusinessStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.988 8.09562L28.7755 1.45788C28.6985 1.2289 28.5487 1.03141 28.3489 0.895572C28.1492 0.759733 27.9104 0.693014 27.6692 0.705606H3.33082C3.08958 0.693014 2.85084 0.759733 2.65108 0.895572C2.45132 1.03141 2.30151 1.2289 2.22453 1.45788L0.0119539 8.09562C-0.00398462 8.21308 -0.00398462 8.33216 0.0119539 8.44963V15.0874C0.0119539 15.3808 0.128509 15.6622 0.335978 15.8696C0.543448 16.0771 0.824837 16.1937 1.11824 16.1937H2.22453V26.1503C2.22453 26.7612 2.71983 27.2565 3.33082 27.2565C3.94181 27.2565 4.43711 26.7612 4.43711 26.1503V16.1937H11.0748V25.2565C11.0748 26.3611 11.9703 27.2565 13.0748 27.2565H26.7755C27.88 27.2565 28.7755 26.3611 28.7755 25.2565V16.1937H29.8818C30.1752 16.1937 30.4566 16.0771 30.664 15.8696C30.8715 15.6622 30.988 15.3808 30.988 15.0874V8.44963C31.004 8.33216 31.004 8.21308 30.988 8.09562ZM26.5629 25.044H13.2874V16.1937H26.5629V25.044ZM28.7755 13.9811H24.3503V10.6622C24.3503 10.0512 23.855 9.55592 23.244 9.55592C22.633 9.55592 22.1377 10.0512 22.1377 10.6622V13.9811H16.6063V10.6622C16.6063 10.0512 16.111 9.55592 15.5 9.55592C14.889 9.55592 14.3937 10.0512 14.3937 10.6622V13.9811H8.86227V10.6622C8.86227 10.0512 8.36696 9.55592 7.75598 9.55592C7.14499 9.55592 6.64969 10.0512 6.64969 10.6622V13.9811H2.22453V8.62664L4.12735 2.91818H26.8727L28.7755 8.62664V13.9811Z",
    fill: "#BEBFC3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessStore);
export default __webpack_public_path__ + "static/media/business-store.987ebf691a647264f47762f143c0a756.svg";
export { ForwardRef as ReactComponent };